/* eslint-env browser */

export const measure = performance.measure.bind(performance)
export const now = performance.now.bind(performance)
export const mark = performance.mark.bind(performance)
